import { APIClient } from "./api_helper";
import axios from "axios";
import * as url from "./url_helper";

const api = new APIClient();

export const getSongLibraries = () => api.get(url.GET_SONG_LIBRARIES);

export const getSongLibrary = (id) => api.get(url.GET_SONG_LIBRARY(id));

export const createSongLibrary = (data) => api.create(url.POST_SONG_LIBRARY, data);

export const updateSongLibrary = (id, data) => api.update(url.PATCH_SONG_LIBRARY(id), data);

export const deleteSongLibrary = (id) => api.delete(url.DELETE_SONG_LIBRARY(id));

export const importSongLibraryCsv = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);

  return axios.post(url.POST_SONG_LIBRARY_IMPORT_CSV(id), formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
